import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const STATUSES = ['pending','assigned','picked_up','delivered','cancelled'];

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [total, setTotal]   = useState(0);
  const [page, setPage]     = useState(1);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    const params = { page, limit: 20, ...(search && { search }), ...(status && { status }) };
    axios.get('/api/orders', { params })
      .then(r => { setOrders(r.data.orders); setTotal(r.data.total); })
      .catch(() => toast.error('Failed to load orders'))
      .finally(() => setLoading(false));
  }, [page, search, status]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { setPage(1); }, [search, status]);

  const updateStatus = async (id, newStatus) => {
    try {
      await axios.patch(`/api/orders/${id}/status`, { status: newStatus });
      toast.success('Status updated');
      load();
    } catch { toast.error('Failed to update'); }
  };

  const totalPages = Math.ceil(total / 20);

  return (
    <div>
      <div className="page-header">
        <div><h1>Orders</h1><p>{total} total orders</p></div>
      </div>

      <div className="card">
        <div className="toolbar">
          <input className="form-control" placeholder="Search order ID, client…" value={search}
            onChange={e => setSearch(e.target.value)} style={{ maxWidth: 260 }} />
          <select className="form-control" value={status} onChange={e => setStatus(e.target.value)} style={{ maxWidth: 160 }}>
            <option value="">All Statuses</option>
            {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>

        {loading
          ? <div className="empty-state"><div className="icon">⏳</div>Loading…</div>
          : orders.length === 0
            ? <div className="empty-state"><div className="icon">📦</div>No orders found</div>
            : <div className="table-wrap">
                <table>
                  <thead>
                    <tr>
                      <th>#ID</th><th>Client</th><th>Store</th><th>Driver</th>
                      <th>Status</th><th>Created</th><th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map(o => (
                      <tr key={o.id}>
                        <td><strong>#{o.id}</strong></td>
                        <td>{o.client_name || '—'}</td>
                        <td>{o.store_name || '—'}</td>
                        <td>{o.driver_name || <span className="text-slate">Unassigned</span>}</td>
                        <td><span className={`badge badge--${o.status}`}>{o.status}</span></td>
                        <td>{new Date(o.created_at).toLocaleDateString()}</td>
                        <td>
                          <select className="form-control" value={o.status} style={{ width: 130 }}
                            onChange={e => updateStatus(o.id, e.target.value)}>
                            {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
        }

        {totalPages > 1 && (
          <div className="pagination">
            <button onClick={() => setPage(p => p - 1)} disabled={page === 1}>← Prev</button>
            <span className="current">Page {page} of {totalPages}</span>
            <button onClick={() => setPage(p => p + 1)} disabled={page === totalPages}>Next →</button>
          </div>
        )}
      </div>
    </div>
  );
}
